export default function PuzzleTimer({ seconds = 0 }) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = String(seconds % 60).padStart(2, '0');

  return (
    <div className="inline-flex items-center rounded-full border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-700 shadow-sm">
      Time: <span className="ml-2 font-mono text-sm sm:text-base">{minutes}:{remainingSeconds}</span>
    </div>
  );
}
